import { render } from "./authorityManage.vue?vue&type=template&id=0bf1dddf&scoped=true"
import script from "./authorityManage.vue?vue&type=script&lang=js"
export * from "./authorityManage.vue?vue&type=script&lang=js"

import "./authorityManage.vue?vue&type=style&index=0&id=0bf1dddf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf1dddf"]])

export default __exports__